import { AUTH_TOKEN } from './constants';

export const setAuthToken = (token) => {
  localStorage?.setItem(AUTH_TOKEN, token);
};
